export const PaymentTrackerDetailsViewUrl = '/business-banking/paymenttracker/v1/payments/transactionreference/status-summary';
export const PaymentTrackerUrl = '/business-banking/paymenttracker';
export const HowToTrackPaymentUrl = 'https://www.commbank.com.au/support.imt.track-international-money-transfer.html';
